module.exports = __webpack_public_path__ + "img/kaidi.bc1dfaa0.jpg";